import PropertySearchFilter from '../property/filters';

const defaultFeatureFilters = {
    parentType: '',
    parentID: 0,
    locationId: 0,
    locationType: '',
    excludeLocationIDs: [],
    boundSW: '',
    boundNE: '',
    skipBoundingBox: false,
    locationIds: [],
};

/**
 * @returns {URLSearchParams}
 */
function newFeatureFilter( filters = {} ): URLSearchParams {
    const template = Object.assign( {}, defaultFeatureFilters, filters );

    const params = new URLSearchParams();

    const keys = Object.keys( template );

    for ( let i = 0; i < keys.length; i++ ) {
        const value = template[ keys[ i ] ];
        if ( value === null || typeof value === 'undefined' ) {
            params.set( keys[ i ], '' );
        } else {
            params.set( keys[ i ], value );
        }
    }

    return params;
}

const defaultPropertyFilters = {
    // currentLocation is the current search location
    // this will always be the type/id in the new system
    currentLocationID: 0,
    currentLocationType: '',
    onlyProperties: false,
    take: 200,
};

/**
 * @returns {URLSearchParams}
 */
function newPropertyFilter( filters = {}, searchForm: HTMLFormElement ): URLSearchParams {
    const filter: PropertySearchFilter = PropertySearchFilter.fromForm( searchForm );

    const propertySearchFilters: URLSearchParams = filter.asURLSearchParams( true );

    propertySearchFilters.set( 'take', defaultPropertyFilters.take.toString() );

    for ( const key in filters ) {
        propertySearchFilters.set( key, filters[ key ] );
    }

    if ( filter.currentLocationID !== null && filter.currentLocationID > 0 && filter.currentLocationType.length > 0 && searchForm ) {
        const locationIdElement: HTMLInputElement | null = searchForm.querySelector( 'input[name="locationId"]' );

        if ( !locationIdElement ) {
            throw new Error( 'failed to find input with name locationId' );
        }

        const isGeocoded = ( locationIdElement.dataset.isGeocoded && locationIdElement.dataset.isGeocoded === 'true' );

        const latitude = parseFloat( locationIdElement.dataset.latitude as string );
        if ( isGeocoded && !isNaN( latitude ) ) {
            propertySearchFilters.set( 'latitude', locationIdElement.dataset.latitude as string );
        }

        const longitude = parseFloat( locationIdElement.dataset.longitude as string );
        if ( isGeocoded && !isNaN( longitude ) ) {
            propertySearchFilters.set( 'longitude', locationIdElement.dataset.longitude as string );
        }
    }

    const keysToIgnore: Array<string> = [ 'locationFreeText', 'locationKey', 'locationId', 'destination' ];

    keysToIgnore.forEach( ( k: string ) => {
        if ( propertySearchFilters.has( k ) ) {
            propertySearchFilters.delete( k );
        }
    } );

    return propertySearchFilters;
}

export {
    defaultPropertyFilters,
    newFeatureFilter,
    newPropertyFilter,
};
